import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";

export default function ClientPortfolioPage() {
  const { token } = useParams();
  const [data, setData] = useState(undefined);
  useEffect(() => {
    api.get(`/public/client-portfolio/${token}`).then((r) => setData(r.data)).catch(() => setData(null));
  }, [token]);
  if (data === undefined) return <div className="min-h-screen grid place-items-center bg-slate-950 text-slate-400">Loading portfolio…</div>;
  if (data === null) return <div className="min-h-screen grid place-items-center bg-slate-950 text-slate-400">This portfolio link is invalid or has been revoked.</div>;
  return (
    <div className="min-h-screen bg-slate-950 text-white" data-testid="client-portfolio-page">
      <header className="border-b border-white/10 px-6 sm:px-12 py-5 flex items-center gap-3">
        {data.logo ? <img src={data.logo} alt="logo" className="h-9 w-auto object-contain" />
          : <span className="inline-flex items-center rounded-lg bg-white/95 px-3 py-1.5"><img src="/symin-logo.png" alt="logo" className="h-8 w-auto object-contain max-w-[170px]" /></span>}
      </header>
      <main className="max-w-4xl mx-auto px-6 sm:px-12 py-12">
        <div className="text-[11px] font-bold tracking-[0.25em] text-[#C20511] uppercase mb-2">Client Portfolio</div>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mb-1">{data.client}</h1>
        <p className="text-slate-400 text-sm mb-10">Exploration projects prepared by {data.company}</p>
        <div className="space-y-3" data-testid="client-portfolio-list">
          {data.projects.map((p, i) => (
            <div key={i} className="rounded-xl border border-white/10 bg-white/5 px-5 py-4 flex items-center gap-4 flex-wrap" data-testid={`cp-project-${i}`}>
              <div className="min-w-0 flex-1">
                <div className="font-bold truncate">{p.name}</div>
                <div className="text-xs text-slate-400">
                  {[p.project_number, p.commodity, p.country].filter(Boolean).join(" · ") || "Exploration project"}
                  {p.area_km2 ? ` · ${p.area_km2} km²` : ""}
                </div>
              </div>
              <span className="text-[10px] font-bold uppercase tracking-wider rounded-full border border-[#C20511]/50 text-[#C20511] px-2.5 py-1">{p.status || "Active"}</span>
            </div>
          ))}
          {data.projects.length === 0 && <div className="text-slate-500 text-sm">No projects in this portfolio yet.</div>}
        </div>
        <p className="text-[11px] text-slate-500 mt-12">Prepared by {data.company}. Confidential - for the intended recipient only.</p>
      </main>
    </div>
  );
}
